
import PhoneNumber from 'awesome-phonenumber'

export function convertToE164Format(input) {
  let phone = new PhoneNumber(input)
  return phone.getNumber()
}
